import { Page, View } from "@react-pdf/renderer"
import { QuestionData } from "../../config/questions"
import { isNumberAnswer, isRadioAnswer } from "../../helpers"
import Footer from "./Footer"
import { Header } from "./Header"
import { Hint } from "./Hint"
import NumberAnswer from "./NumberAnswer"
import { PageWrapper } from "./PageWrapper"
import QuestionPage from "./QuestionPage"
import RadioAnswer from "./RadioAnswer"
import Summary from "./Summary"

type QuestionsPageProps = {
  questions: QuestionData[]
  indicatorText: string
  goodText: string
  poorText: string
  score: number
}

export const QuestionsPage = ({
  questions,
  indicatorText,
  goodText,
  poorText,
  score,
}: QuestionsPageProps) => {
  return (
    <Page size="A4" wrap>
      <PageWrapper>
        <Header />

        <Summary
          score={score}
          indicator={indicatorText}
          poor={poorText}
          good={goodText}
        />

        <View>
          {questions.map((q, idx) => {
            if (isRadioAnswer(q.answer)) {
              const selectedAnswer = q.answer.options.find(
                (o) => o.selected === true,
              )
              if (!selectedAnswer) return null

              return (
                <View key={idx} wrap={false} style={{ marginBottom: 24 }}>
                  <QuestionPage idx={idx + 1} text={q.text} question={q}>
                    <>
                      <RadioAnswer
                        key={q.text}
                        selectedAnswer={selectedAnswer}
                      />
                      <Hint hint={selectedAnswer.hint} />
                    </>
                  </QuestionPage>
                </View>
              )
            }

            if (isNumberAnswer(q.answer) && q.answer?.value) {
              return (
                <View key={idx} wrap={false} style={{ marginBottom: 24 }}>
                  <QuestionPage idx={idx + 1} text={q.text} question={q}>
                    <>
                      <NumberAnswer
                        key={q.text}
                        value={q.answer.value}
                        placeholder={q.answer.placeholder}
                      />
                      <Hint hint={q.answer.hint} />
                    </>
                  </QuestionPage>
                </View>
              )
            }
          })}
        </View>
      </PageWrapper>

      <Footer style={{ paddingHorizontal: 64 }} />
    </Page>
  )
}
